import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
    Snackbar,
  Alert
} from "@mui/material";
import { logout, extendSessionHour } from './slice/authSlice';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';

const SessionExpiryModal = ({ open = true, expiresAt, extendOptions = [], onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState("");
  const [extending, setExtending] = useState(false);
   const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        setTimeout(() => navigate('/signin'), 100);
        // disconnectSocket(); // Make sure you have this function
        onClose();
      })
      .catch((err) => console.error("Logout error:", err));
  };

  const handleExtend = async (hours) => {
    setExtending(true);
    try {
    const result  =  await dispatch(extendSessionHour(hours)).unwrap();
      console.log(`✅ Session extended by ${hours} hour(s)`);
       const newExpiryTime = new Date(result.expiresAt).toLocaleTimeString();
          setSuccessMessage(`✅ Session extended to ${newExpiryTime}`)
      onClose(); // Close modal after extension
    } catch (error) {
      console.error("❌ Failed to extend session:", error);
    } finally {
      setExtending(false);
    }
  };

  useEffect(() => {
    if (!open || !expiresAt) return;

    const timer = setInterval(() => {
      const diff = new Date(expiresAt) - new Date();

      if (diff <= 0) {
        setTimeLeft("Session expired");
        clearInterval(timer);
        return;
      }

      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(timer);
  }, [expiresAt, open]);

  if (!open) return null;

  return (
    <>
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ bgcolor: '#ff9800', color: 'white' }}>
        ⚠️ Session Expiring Soon
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="h6" align="center" gutterBottom>
          Time Remaining: <b>{timeLeft}</b>
        </Typography>

        <Typography sx={{ mt: 2, mb: 1 }}>
          Your session will expire soon. Would you like to extend it?
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select extension time:
        </Typography>

        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "center" }}>
          {extendOptions.map((hours) => (
            <Button
              key={hours}
              variant="contained"
              color="success"
              onClick={() => handleExtend(hours)}
              disabled={extending}
              sx={{ minWidth: '80px' }}
            >
              {hours} {hours > 1 ? "Hrs" : "Hr"}
            </Button>
          ))}
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', p: 2 }}>
        <Button 
          color="error" 
          variant="outlined" 
          onClick={handleLogout}
          disabled={extending}
        >
          Logout Now
        </Button>
        {/* <Button 
          color="primary" 
          variant="text" 
          onClick={onClose}
          disabled={extending}
        >
          Remind Later
        </Button> */}
      </DialogActions>
    </Dialog>

        <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          {successMessage}
        </Alert>
      </Snackbar>
      </>

  );
};

export default SessionExpiryModal;